import { createMotionProxy } from './motion-proxy.js';
import { createDomMotionConfig } from './utils/create-config.js';

/**
 * @public
 */
var m = createMotionProxy(createDomMotionConfig);

export { m };
